import {style} from "typestyle";
import backgroundImage from "./background.jpg";

export const background = style({
    background: `center / cover no-repeat url("${backgroundImage}")`,
})